import styled from 'styled-components';

export default styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  padding: 5rem;
  z-index: 100;
  width: 100%;
  height: 100%;
`;
